import { ColorScheme } from '@unifyapps/defs/types/interface';
import { useEffect, useState } from 'react';
import { useGlobalAppStateStore } from '../stores/app/GlobalAppStateStore';

export const useDataColorScheme = () => {
  const colorSchemeDetails = useGlobalAppStateStore().hooks.useColorSchemeDetails();

  const [effectiveColorScheme, setEffectiveColorScheme] = useState<ColorScheme>(() => {
    return colorSchemeDetails?.originalColorScheme === ColorScheme.SYSTEM
      ? ColorScheme.LIGHT
      : colorSchemeDetails?.effectiveColorScheme;
  });

  useEffect(() => {
    if (colorSchemeDetails?.effectiveColorScheme !== effectiveColorScheme) {
      setEffectiveColorScheme(colorSchemeDetails?.effectiveColorScheme);
    }
  }, [colorSchemeDetails?.effectiveColorScheme, effectiveColorScheme]);

  return effectiveColorScheme;
};
